// DialogUserAddAbsent Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../layout/dialog/dialog.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import FormDatePicker from '../../form/form_datepicker/form_datepicker.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import TimeSlider from '../../common/time_slider/time_slider.jsx'

class DialogUserAddAbsent extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      showError: false,
      dataDate: null
    }

    this.data = {
      normalTypes: [
        { label: 'user.form.typeHoliday', value: 'Holiday' },
        { label: 'user.form.typeSickLeave', value: 'SickLeave' },
        { label: 'user.form.typeMeeting', value: 'Meeting' },
        { label: 'user.form.typeTraining', value: 'Training' },
        { label: 'user.form.typeDoctorOrDentist', value: 'Doctor/Dentist' },
        { label: 'user.form.typeOther', value: 'Other' }
      ],
      absent: this._createAbsentObject()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null
    }
  }

  show () {
    this.data.absent = this._createAbsentObject()
    this.setState({ active: true, dataDate: new Date() })
  }

  hide () {
    this.setState({
      active: false,
      showError: false
    })
  }

  render () {
    const absent = this.data.absent
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'

    return (
      <Dialog active={this.state.active} onClose={this.hide.bind(this)}>
        <div className='dialog-form dialog-user-addabsent'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='user.form.addAbsentTitle' />
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='user.form.addAbsentErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormDatePicker
                          label='user.form.date'
                          placeholder='user.form.enterDate'
                          value={absent.leaveDate}
                          name='leaveDate'
                          onChange={this._onChangeDate.bind(this, 'leaveDate')}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol2'>
                        <div className='graph'>
                          <TimeSlider
                            fromTime={absent.fromTime}
                            toTime={absent.toTime}
                            showMarker
                            onChange={this._onChangeSlider.bind(this)}
                          />
                        </div>
                      </div>
                      <div className='formcol2'>
                        <div className='form-type'>{this._renderType()}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              title='user.form.createAbsentTitle'
              canHover={false}
              onClick={this._onFormSubmit.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onFormSubmit (ev) {
    ev.preventDefault()

    let noErrors = 0
    if (this.data.absent && !this.data.absent.type) {
      noErrors++
    }

    if (noErrors === 0) {
      const data = {
        leaveDate: this.data.absent.leaveDate,
        type: this.data.absent.type,
        fullDay:
          this.data.absent.fromTime === 9 * 60 &&
          this.data.absent.toTime === 17 * 60,
        fromTime: this.data.absent.fromTime,
        toTime: this.data.absent.toTime
      }

      if (this.props.onSubmit) {
        this.props.onSubmit(data)
      }
    } else {
      this.setState({ showError: true })
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _onChangeInput (name, value) {
    this.data.absent[name] = value

    this._refresh()
  }

  _onTypeClick (type, e) {
    e.preventDefault()
    if (type !== this.data.absent.type) {
      this.data.absent.type = type
    } else {
      this.data.absent.type = ''
    }

    this._refresh()
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  _onChangeDate (name, value) {
    this.data.absent[name] = value

    this._refresh()
  }

  /* Private functions */
  _createAbsentObject () {
    return {
      leaveDate: new Date(),
      fromTime: 9 * 60,
      toTime: 17 * 60,
      type: ''
    }
  }

  _renderType () {
    if (this.data.normalTypes && this.data.normalTypes.length > 0) {
      return this.data.normalTypes.map((type, idx) => {
        let className = 'form-type-item'
        if (type.value === this.data.absent.type) {
          className = 'form-type-item active'
        }

        return (
          <div
            className={className}
            key={idx}
            onClick={this._onTypeClick.bind(this, type.value)}
          >
            <IntlMessage ident={type.label} />
          </div>
        )
      })
    }

    return ''
  }

  _onChangeSlider (fromTime, toTime) {
    this.data.absent.fromTime = fromTime
    this.data.absent.toTime = toTime

    this._refresh()
  }
}

export default DialogUserAddAbsent
